// externals
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useRef, useState } from 'react';
import { useResizeObserver } from '@makemydeal/dr-shared-ui-utils';

// local components
import SearchAndSelectVehicleContent from './SearchAndSelectVehicleContent';

import VehicleSearchFiltersInline from './VehicleSearchFiltersInline';
import VehicleSearchFiltersSlideOut from './VehicleSearchFiltersSlideOut';

// styles
import { SearchAndSelectVehicleContainerWrapper } from './ChangeVehicle.interstate.style';

// store
import { changeVehicleSelectors, middlewareMgr } from '../../store';
import { MAX_MOBILE_WIDTH_PX } from '../../constants';
import { createPageLoadEvent } from '../../analytics';

const SearchAndSelectVehicle = () => {
    const dispatch = useDispatch();
    const showFiltersPanel = useSelector(changeVehicleSelectors.getIsFiltersInitialized);

    const containerRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        const pageLoadEvent = createPageLoadEvent();
        const forwardAction = middlewareMgr.hostActions.forwardCDLEvent(pageLoadEvent.payload);
        dispatch(forwardAction);
    }, [dispatch]);

    const [isSearchVehicleTabActive, setIsSearchVehicleTabActive] = useState(true);
    const [isMobile, setIsMobile] = useState(false);

    const handleTabChange = (isSearchTab: boolean) => {
        setIsSearchVehicleTabActive(isSearchTab);
    };

    useResizeObserver(containerRef, (entry) => {
        const containerWidth = entry.borderBoxSize[0].inlineSize;
        setIsMobile(containerWidth < MAX_MOBILE_WIDTH_PX);
    });

    return (
        <SearchAndSelectVehicleContainerWrapper ref={containerRef}>
            {showFiltersPanel && isMobile && <VehicleSearchFiltersSlideOut />}
            {showFiltersPanel && !isMobile && <VehicleSearchFiltersInline isSearchVehicleTabActive={isSearchVehicleTabActive} />}
            <SearchAndSelectVehicleContent onTabChange={handleTabChange} isMobileView={isMobile} />
        </SearchAndSelectVehicleContainerWrapper>
    );
};

export default SearchAndSelectVehicle;
